import angular from 'angular';
import { every } from 'lodash';

module.exports = angular.module('common.filters.none-selected', [])
.filter('noneSelected', function () {
  return function(value) {
    return every(value, function(v) { return !v; });
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/none-selected.js
 **/